import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { CoreState } from '../core.state';
import { selectConfig } from '../../modules/config/config.selector';
import { selectUrlParams } from '../../modules/url-params/url-params.selector';
import { SignInfo } from '../model/authorization/sign-info.model';
import { AuthorizationStatus } from '../model/authorization/authorization-status.model';
import { ConfigModel } from '../../modules/config/config.model';
import { UrlParams } from '../../modules/url-params/model/url-params.model';
import { AbstractRestClient } from './abstract-rest-client.service';

import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/combineLatest';

/**
 * REST Client retrieve authorization status.
 * Client depends on config and access_token. Both has to be available in the store before using this client.
 *
 * see http://docs.int0csaspsd2selfservice.apiary.io/
 */
@Injectable()
export class StatusRestClient extends AbstractRestClient {

    ssfUrl: string;

    constructor(private http: HttpClient, private store: Store<CoreState>) {
        super();

        this.store.select(selectConfig)
            .combineLatest(this.store.select(selectUrlParams))
            .filter(([config, urlParams]: ([ConfigModel, UrlParams])) => !!config  &&  !!urlParams)
            .subscribe(([config, urlParams]: ([ConfigModel, UrlParams])) => {
                this.ssfUrl = config ? config.apiUrl.ssf : null;
                this.init(urlParams.access_token, config.webApiKey, urlParams.lang);
            });
    }

    /**
     * Method to get authorization status.
     *
     * https://int0csaspsd2selfservice.docs.apiary.io/#reference/autorizace/stav-autorizace/stav-autorizace
     *
     * @param {SignInfo} signInfo
     */
    public getStatus(signInfo: SignInfo): Observable<AuthorizationStatus> {
        return this.http.get<AuthorizationStatus>(this.ssfUrl + `/sign/${signInfo.signId}/status`,
            {
                headers: this.headers()
            });
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/services/status-rest-client.service.ts